// extracted by mini-css-extract-plugin
export var brand = "_p-9";
export var button = "_p-0";
export var chevron = "_p-v";
export var chevronButton = "_p-w";
export var content = "_p-n";
export var danger = "_p-g";
export var dangerOutlined = "_p-h";
export var dark = "_p-l";
export var darkTheme = "_p-c";
export var extraSmall = "_p-4";
export var fullWidth = "_p-8";
export var ghost = "_p-d";
export var gray = "_p-t";
export var icon = "_p-p";
export var iconButton = "_p-s";
export var iconButtonBorder = "_p-x";
export var iconButtonBorderDark = "_p-y";
export var iconButtonBorderLight = "_p-z";
export var iconLeft = "_p-q";
export var iconRight = "_p-r";
export var large = "_p-1";
export var light = "_p-m";
export var medium = "_p-2";
export var micro = "_p-5";
export var nano = "_p-7";
export var outlined = "_p-k";
export var pending = "_p-a";
export var primary = "_p-i";
export var shadow = "_p-o";
export var small = "_p-3";
export var solidLight = "_p-e";
export var solidLightBrand = "_p-f";
export var spinner = "_p-u";
export var transparent = "_p-j";
export var warning = "_p-b";
export var wideNano = "_p-6";